import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propChildren } from '../../helpers/custom-prop-types';
import Footer from '../Footer';
import HeaderMaintenance from '../Header/Maintenance';
const MaintenanceLayout = ({ children }) => (_jsxs(_Fragment, { children: [_jsx(HeaderMaintenance, {}), children, _jsx(Footer, {})] }));
MaintenanceLayout.propTypes = {
    children: propChildren().isRequired,
};
export default MaintenanceLayout;
